const getHideGlobalAlertBannerEventProcessor = (props) => {
    const { setIsGlobalBannerAlertVisible } = props;
    return {
        validateEventPayload: () => ({ isValid: true }),
        executeEvent: async () => {
            setIsGlobalBannerAlertVisible(false);
            return Promise.resolve();
        },
    };
};
export { getHideGlobalAlertBannerEventProcessor };
//# sourceMappingURL=index.js.map